import React, { Component } from 'react'
import GlobalStyles from '../styles/global.module.scss'
import Styles from './styles/PracticeInfo.module.scss'
import Constants from '../../values.js'
import Config from '../../config'
import * as Metadata from '../../metadata.js'
import { ToastContainer, toast } from 'react-toastify'
import moment from 'moment'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import Button from 'react-bootstrap/Button'
import Select from 'react-select'
import {
  stopTimer,
  resetTimer,
  startTimer,
  setAppointmentNotesData,
  fetchPatientCarePlanData,
  addPatientList,
  addPatient,
  toggleSidebar,
  fetchPatientCoreDate,
  fetchPatientProgressData,
  fetchPatientWellnessScreening,
  fetchPatientCalculateProgressData,
  fetchPatientConditions,
  fetchPatientMedications,
  fetchPatientLabs,
  updatePatientData,
  updateSideNavBar,
  addPatientLP,
} from '../../redux/actions'
import Table from '../../components/Table'
import { providerReferralsColumns } from './Columns/providerReferralsColumns'
import { referringProvidersColumn } from './Columns/referringProvidersColumn'
import { timeSpentColumns } from './Columns/timeSpentColumns'
// import DatePicker from '../../components/DatePicker'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

const axios = require('axios')

const customModalStyles = {
  overlay: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.44)',
  },
  content: {
    width: '60%',
    height: '80%',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 100,
  },
}

class TimeSpent extends Component {
  constructor(props) {
    super(props)
    let notesData = this.props?.carePlanNotesData
    let reduxAppNotes = this.props?.appointmentNotesData

    this.state = {
      loading: false,
      showInbox: true,
      columnData: [],
      searchMonth: new Date(),
      referrals: [],
      referringProviders: [],
      showReferringModal: false,
      providerMap: {},
      patientList: [],
      patientMap: {},
      events: null,
      pdfData: '',
      showModal: false,
      //REFERRING PROVIDER MODAL
      type: null,
      firstName: '',
      lastName: '',
      specialty: null,
      organization: '',
      phone: '',
      email: '',
      fax: '',
      state: '',
      allProviders: [],
      provider_availabilities: [],
    }
    this.fuse = null
    this.imageUploadRef = React.createRef()
    this.fileRef = React.createRef()
    this.getAllProviders = this.getAllProviders.bind(this)
    this.preparePatientList = this.preparePatientList.bind(this)
    this.getEventsFromBackendOnly = this.getEventsFromBackendOnly.bind(this)
    this.getReferringProviders = this.getReferringProviders.bind(this)
    this.navigatetoPatientProfile = this.navigatetoPatientProfile.bind(this)
    this.saveAppointmentData = this.saveAppointmentData.bind(this)
    this.saveRefrringProvider = this.saveRefrringProvider.bind(this)
  }

  componentDidMount() {
    if (!this.props.loggedIn) {
      this.props.history.push('/login')
      return
    }
    this.setState({ loading: true })
    this.getEventsFromBackendOnly()
    this.getReferringProviders()
    this.getAllProviders()
  }

  async getAllProviders() {
    const { token, adminId } = this.props

    // get all providers
    const url = `${Config.BACKEND_URL}providers`

    axios({
      method: 'get',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Accept: '*/*',
        Authorization: `JWT ${token}`,
        x_firebase_id: adminId,
        getallproviders: true,
      },
      url,
    })
      .then(async ({ data }) => {
        let docObj = {}
        if (data) {
          this.setState({ allProviders: data })
          let provider_availabilities = []
          // console.log(data)
          data.forEach((provider) => {
            let total_minutes = 0
            provider?.availability &&
              Object.keys(provider?.availability).forEach((avail) => {
                let total_days = 0
                var day_of_month = moment(this.state.searchMonth)
                  .startOf('month')
                  .day(avail)
                if (day_of_month.date() > 7) day_of_month.add(7, 'd')
                var month = day_of_month.month()
                //CALCULATING TOTAL DAYS (MON, TUES, WED) IN THE MONTH
                while (month === day_of_month.month()) {
                  total_days = total_days + 1
                  day_of_month.add(7, 'd')
                }
                // avail = Mon, Tue, Wed ...
                if (provider?.availability?.[avail]?.length) {
                  provider.availability[avail] &&
                    provider.availability[avail].forEach((time) => {
                      let availTimeStart = moment(time?.start)
                      let availTimeEnd = moment(time?.end)
                      // splitting the block of time into 30 minutes chunks
                      var duration = moment.duration(
                        availTimeEnd.diff(availTimeStart),
                      )
                      total_minutes =
                        total_minutes + duration.asMinutes() * total_days
                    })
                }
              })
            provider_availabilities.push({
              provider_id: provider?.firebase_id,
              time: total_minutes,
            })
          })
          console.log(provider_availabilities)
          this.setState({ provider_availabilities: provider_availabilities })
          data.forEach((x) => {
            docObj[x.firebase_id] = x
          })
          this.setState(
            {
              providerMap: docObj,
            },
            () => this.preparePatientList(),
          )
        }
      })
      .catch((err) => {
        console.log('error when getting all providers', err)
        toast.error('Something went wrong')
        this.setState({ loading: false, showScheduleModal: false })
      })
  }

  saveAppointmentData(appointment, reviewed) {
    let { token, adminId } = this.props
    console.log('save reviwed')
    this.setState({ loading: true })
    axios({
      method: 'put',
      url: `${Config.BACKEND_URL}appointment`,
      headers: {
        Authorization: `JWT ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        event_id: appointment.event_id,
        ...{
          reviewed: reviewed,
          reviewed_by: { supervisor: adminId, date: new Date() },
        },
      },
    })
      .then((result) => {
        console.log('updated appointment')
        this.getEventsFromBackendOnly()
      })
      .catch((err) => {
        this.setState({ loading: false })
        toast.error('Something went wrong, please try again')
        console.log('error when updating appointment', err)
      })
  }

  async preparePatientList(data) {
    const { patientList } = this.props
    if (!patientList) return
    let patientListData = data || patientList
    const patientMap = {}
    const list = []
    Object.keys(patientListData).forEach((rpmColor) => {
      const patientsColorList = patientListData[rpmColor]
      patientsColorList.forEach((patient) => {
        patientMap[patient.uid] = patient
        list.push({
          label: `${patient.firstName} ${patient.lastName}`,
          value: patient.uid,
        })
      })
    })

    this.setState({ patientMap, patientList: list }, () =>
      this.getEventsFromBackendOnly(),
    )
  }

  async getEventsFromBackendOnly() {
    const { token, mongoUser, firebaseUser } = this.props
    const url = `${Config.BACKEND_URL}time-spent/provider`
    try {
      const response = await axios({
        method: 'get',
        url,
        headers: {
          Authorization: `JWT ${token}`,
          x_doctor_id: mongoUser.firebase_id,
          search_month:
            moment(
              moment(this.state.searchMonth).format('YYYY-MM-DD'),
            ).month() + 1,
          search_year: moment(
            moment(this.state.searchMonth).format('YYYY-MM-DD'),
          ).year(),
        },
      })

      const events = response.data
      console.log(events)
      this.setState({ columnData: events || [] })
      this.setState({ loading: false })
    } catch (err) {
      toast.error('Could not fetch referrals, please try again')
      console.log('error when getting referrals from backend', err)
    }
  }

  async getReferringProviders() {
    const { token, mongoUser, firebaseUser } = this.props
    const url = `${Config.BACKEND_URL}referring-providers`
    try {
      const response = await axios({
        method: 'get',
        url,
        headers: {
          Authorization: `JWT ${token}`,
          x_doctor_id: mongoUser.firebase_id,
        },
      })

      const events = response.data
      this.setState({ referringProviders: events || [] })
      this.setState({ loading: false })
    } catch (err) {
      toast.error('Could not fetch referring providers, please try again')
      console.log('error when getting referrals from backend', err)
    }
  }

  async saveRefrringProvider() {
    const { token, mongoUser, firebaseUser } = this.props
    let {
      firstName,
      lastName,
      organization,
      phone,
      email,
      specialty,
      state,
      fax,
    } = this.state
    this.setState({ loading: true })

    const url = `${Config.BACKEND_URL}referring-providers`
    let data = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      phone: phone,
      fax: fax,
      organization: organization,
      state: state,
      specialty: specialty,
      created_at: moment.utc().format(),
    }
    // console.log(data)
    try {
      const response = await axios({
        method: 'post',
        url,
        headers: {
          Authorization: `JWT ${token}`,
          x_doctor_id: mongoUser.firebase_id,
        },
        data: data,
      })

      const events = response.data

      console.log('Saved referring provider')
      this.getReferringProviders()
      this.setState({
        loading: false,
        type: null,
        firstName: '',
        lastName: '',
        specialty: null,
        organization: '',
        phone: '',
        email: '',
        fax: '',
        state: '',
      })
    } catch (err) {
      toast.error('Could not fetch referring providers, please try again')
      console.log('error when getting referrals from backend', err)
      this.setState({ loading: false })
    }
  }

  onPatientNavLinkClicked = (lp) => {
    this.props.addPatientLP(lp)
    console.log('PATIENT LANDING PAGE: ', lp)
  }

  navigatetoPatientProfile = (p_id) => {
    const { patientList, patientTimer, updateRender, adminId, token } =
      this.props
    console.log('testing on click: ', p_id)
    if (!patientList) return

    Object.values(patientList).forEach((colorCodedPatients, index) => {
      if (colorCodedPatients.length > 0) {
        let result = colorCodedPatients.filter(
          (patient) => patient.uid === p_id,
        )
        // console.log('RESUKT ARRAY : ', result)
        result.forEach((patient) => {
          let colorcode = Object.keys(patientList)[index]
          if (patient.uid === p_id) {
            this.props.updatePatientData(
              {
                doctor_id: adminId,
                patient_id: patient.uid,
                last_reviewed: new Date(),
              },
              token,
            )

            //if the doctor was already on on another patient page and just clicked on a new patient, reset time
            if (patientTimer && patientTimer !== 0)
              this.props.resetTimer(patient.uid, adminId, token)
            else this.props.startTimer(patient.uid)
            let preferences = patient.preferences
            let timeline = 'complete'
            if (preferences && preferences.timeline) {
              timeline = preferences.timeline.value
            }
            this.props.fetchPatientProgressData(patient.uid, token, timeline)
            this.props.fetchPatientCoreDate(patient.uid, token)
            this.props.fetchPatientWellnessScreening(patient.uid, token)
            this.props.fetchPatientCalculateProgressData(patient.uid, token)
            this.props.fetchPatientConditions(patient.uid, token)
            this.props.fetchPatientMedications(patient.uid, token)
            this.props.fetchPatientLabs(patient.uid, token)
            this.props.addPatient(patient, colorcode)
            this.props.updateSideNavBar(!updateRender)
          }
        })
      }
    })
  }

  renderReferringProviderModal() {
    return (
      <div
        style={{
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '1%',
        }}
      >
        <p
          className={Styles.closeModalBtn}
          onClick={() => {
            this.props.toggleSidebar(false)
            this.setState({ showReferringModal: false })
          }}
        >
          X
        </p>
        <h4 style={{ color: Constants.primaryTheme, textAlign: 'center' }}>
          Add Referral Partner
        </h4>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            padding: '5% 0% 5% 4%',
          }}
        >
          <div className={Styles.row} style={{ position: 'relative' }}>
            <p className={Styles.rowLabel}>First Name</p>

            <input
              placeholder={'Enter First Name'}
              className={Styles.studyEntryInput}
              type="text"
              value={this.state.firstName}
              onChange={(e) => this.setState({ firstName: e.target.value })}
            />
          </div>
          <div className={Styles.row}>
            <p className={Styles.rowLabel}>Last Name</p>

            <input
              placeholder={'Enter Last Name'}
              className={Styles.studyEntryInput}
              type="text"
              value={this.state.lastName}
              onChange={(e) => this.setState({ lastName: e.target.value })}
            />
          </div>
          <div className={Styles.row}>
            <p className={Styles.rowLabel}>Specialty</p>
            <div style={{ width: '60%' }}>
              <Select
                placeholder="Select specialty"
                inputId="specialty"
                options={Metadata.SPECIALITY_OPTIONS}
                value={this.state.specialty ? this.state.specialty : null}
                isMulti={false}
                isSearchable
                autoBlur
                onChange={(val) => {
                  this.setState({ specialty: val })
                }}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: '#20A89233',
                    primary: '#20A892',
                  },
                })}
              />
            </div>
          </div>

          <div className={Styles.row}>
            <p className={Styles.rowLabel}>Organization</p>
            <input
              placeholder={'Enter Organization'}
              className={Styles.studyEntryInput}
              type="text"
              value={this.state.organization}
              onChange={(e) => this.setState({ organization: e.target.value })}
            />
          </div>

          <div className={Styles.row}>
            <p className={Styles.rowLabel}>State</p>
            <div style={{ width: '60%' }}>
              <Select
                placeholder={'Select'}
                isMulti={false}
                options={Metadata.stateResidence}
                value={this.state.state ? this.state.state : null}
                onChange={(val) => this.setState({ state: val })}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: '#20A89233',
                    primary: '#20A892',
                  },
                })}
              />
            </div>
          </div>

          <div className={Styles.row}>
            <p className={Styles.rowLabel}>Email</p>
            <input
              placeholder={'Enter Email'}
              className={Styles.studyEntryInput}
              type="text"
              value={this.state.email}
              onChange={(e) => this.setState({ email: e.target.value })}
            />
          </div>
          <div className={Styles.row}>
            <p className={Styles.rowLabel}>Fax Number</p>
            <input
              placeholder={'Enter Fax Name'}
              className={Styles.studyEntryInput}
              type="text"
              value={this.state.fax}
              onChange={(e) => this.setState({ fax: e.target.value })}
            />
          </div>
          <div className={Styles.row}>
            <p className={Styles.rowLabel}>Phone</p>
            <input
              placeholder={'Enter Phone'}
              className={Styles.studyEntryInput}
              type="text"
              value={this.state.phone}
              onChange={(e) => this.setState({ phone: e.target.value })}
            />
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'center',
          }}
        >
          <Button
            onClick={() => {
              this.saveRefrringProvider()
            }}
            className={GlobalStyles.button}
            style={{ width: 300, margin: '4%' }}
            variant="primary"
          >
            Save
          </Button>
        </div>
      </div>
    )
  }

  render() {
    if (this.state.loading) {
      return (
        <div
          className={GlobalStyles.container}
          style={{ overflow: 'hidden', maxHeight: '100vh' }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: '100%',
              height: '80vh',
            }}
          >
            <div className={GlobalStyles.loader} />
          </div>
        </div>
      )
    }

    return (
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        <h4
          style={{
            color: Constants.primaryTheme,
            width: '100%',
            marginBottom: 10,
            textAlign: 'center',
          }}
        >
          Time Spent
        </h4>
        <div style={{ alignSelf: 'center' }}>
          Search Date
          <DatePicker
            dateFormat="MMMM yyyy"
            showMonthYearPicker
            selected={this.state.searchMonth}
            onChange={(date) => {
              console.log(date)
              this.setState({ searchMonth: date }, () => {
                this.getAllProviders()
                this.getEventsFromBackendOnly()
              })
            }}
          />
          {/* <DatePicker
            defaultDate={moment().format()}
            dateChange={(date) => {
              console.log(date)
              this.setState({ searchMonth: date })
            }}
          /> */}
        </div>
        {/* <div style={{ width: '100%', position: 'relative' }}>
          <div
            style={{
              width: 300,
              height: 40,
              border: '1px solid black',
              borderRadius: 4,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '2vw',
            }}
          >
            <div
              onClick={() =>
                this.setState({ showInbox: true }, () =>
                  // this.getInbox(false),
                  console.log('patients'),
                )
              }
              style={{
                borderRadius: 4,
                cursor: 'pointer',
                width: '50%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: this.state.showInbox
                  ? Constants.primaryTheme
                  : 'white',
              }}
            >
              <p
                style={{
                  color: this.state.showInbox ? 'white' : 'black',
                }}
              >
                Patients
              </p>
            </div>
            <div
              onClick={() =>
                this.setState({ showInbox: false }, () =>
                  // this.getOutbox(),
                  console.log('providers'),
                )
              }
              style={{
                borderRadius: 4,
                cursor: 'pointer',
                width: '50%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: !this.state.showInbox
                  ? Constants.primaryTheme
                  : 'white',
              }}
            >
              <p
                style={{
                  color: !this.state.showInbox ? 'white' : 'black',
                }}
              >
                Providers
              </p>
            </div>
          </div>
          {!this.state.showInbox && (
            <div style={{ position: 'absolute', top: 0, right: '5%' }}>
              <FontAwesomeIcon
                onClick={() => {
                  this.props.toggleSidebar(true)
                  this.setState({ showReferringModal: true })
                }}
                icon={faPlusCircle}
                style={{
                  color: Constants.primaryTheme,
                  fontSize: 'x-large',
                  right: 14,
                  cursor: 'pointer',
                }}
              />
            </div>
          )}
        </div> */}

        <div className={GlobalStyles.contentWrapper}>
          {this.state.showInbox ? (
            <Table
              columns={timeSpentColumns(
                this.props.invitePatientClicked,
                this.state.provider_availabilities,
              )}
              data={this.state.columnData}
            />
          ) : (
            <Table
              columns={referringProvidersColumn()}
              data={this.state.referringProviders}
            />
          )}

          <Modal
            ariaHideApp={false}
            isOpen={this.state.showReferringModal}
            onRequestClose={() => {
              this.props.toggleSidebar(false)
              this.setState({ showReferringModal: false })
            }}
            style={customModalStyles}
            contentLabel="Modal"
          >
            {this.renderReferringProviderModal()}
          </Modal>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    loggedIn: state.userReducer.loggedIn,
    token: state.authReducer.token,
    docFirebaseAuthUser: state.userReducer.firebaseAuthUser,
    mongoUser: state.userReducer.mongoUser,
    adminId: state.userReducer.adminId,
    patientList: state.patientReducer.patientList,
    doctorPatientData: state.appointmentReducer.patientData,
    appointmentData: state.appointmentReducer.appointmentData,
    patient: state.patientReducer.patient,
    appointmentNotesData: state.appointmentReducer.appointmentNotesData,
    openNotesModal: state.genericReducer.openNotesModal,
  }
}

const mapDispatchToProps = {
  stopTimer,
  resetTimer,
  startTimer,
  setAppointmentNotesData,
  fetchPatientCarePlanData,
  addPatientList,
  toggleSidebar,
  fetchPatientCoreDate,
  fetchPatientProgressData,
  fetchPatientWellnessScreening,
  fetchPatientCalculateProgressData,
  fetchPatientConditions,
  fetchPatientMedications,
  fetchPatientLabs,
  updatePatientData,
  updateSideNavBar,
  addPatientLP,
  addPatient,
}

export default connect(mapStateToProps, mapDispatchToProps)(TimeSpent)
